module.exports = __webpack_public_path__ + "static/media/marketing.6e4046a0.png";